<template>
  <v-container>
    <v-dialog width="300" v-model="dialog" persistent>
      <v-card class="p-4">
        <!-- <v-card-title>Indicadores</v-card-title> -->
        <v-form ref="form" lazy-validation v-model="valid">
          <v-card-text>
            <v-text-field
              label="Árboles"
              type="number"
              outlined
              dense
              v-model="indicadores.arboles"
              :rules="[rules.required]"
            ></v-text-field>
            <v-text-field
              label="CO2"
              type="number"
              outlined
              dense
              v-model="indicadores.co2"
              :rules="[rules.required]"
            ></v-text-field>
            <v-text-field
              label="Viajes"
              type="number"
              outlined
              dense
              v-model="indicadores.viajes"
              :rules="[rules.required]"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="success"
              :disabled="!valid"
              @click.prevent="updateIndicadores"
            >Guardar cambios</v-btn>
            <v-btn color="error" @click="dialog = false; getIndicadores()">Cancelar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Árboles</th>
            <th class="text-left">
              CO
              <sub>2</sub>
            </th>
            <th class="text-left">Viajes</th>
            <th class="text-center">Editar</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ indicadores.arboles || 0 }}</td>
            <td>{{ indicadores.co2 || 0 }}</td>
            <td>{{ indicadores.viajes || 0 }}</td>
            <td class="text-center">
              <v-btn color="warning" text small @click="dialog = true">
                <i class="fa fa-pencil"></i>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>-->

    <v-row>
      <v-col>
        <v-form ref="form" lazy-validation v-model="indicadores.formCo2">
          <v-card>
            <v-card-text>
              <!-- <h1>5</h1> -->
              <v-text-field
                outlined
                label="Ton de Co2 ahorradas"
                type="number"
                hide-details
                v-model="indicadores.co2"
                :rules="[rules.required]"
              ></v-text-field>
              <v-divider class="my-2"></v-divider>
              <div class="text-right">
                <v-btn small color="primary" :disabled="!indicadores.formCo2" @click="update('co2')">Actualizar</v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
      <v-col>
        <v-form ref="form" lazy-validation v-model="indicadores.formarboles">
          <v-card>
            <v-card-text>
              <!-- <h1>5</h1> -->
              <v-text-field
                outlined
                label="Árboles nativos plantados"
                type="number"
                hide-details
                v-model="indicadores.arboles"
                :rules="[rules.required]"
              ></v-text-field>
              <v-divider class="my-2"></v-divider>
              <div class="text-right">
                <v-btn small color="primary" :disabled="!indicadores.formarboles" @click="update('arboles')">Actualizar</v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
      <v-col>
        <v-form ref="form" lazy-validation v-model="indicadores.formviajes">
          <v-card>
            <v-card-text>
              <!-- <h1>5</h1> -->
              <v-text-field
                outlined
                label="Viajes automovil ahorrados"
                type="number"
                hide-details
                v-model="indicadores.viajes"
                :rules="[rules.required]"
              ></v-text-field>
              <v-divider class="my-2"></v-divider>
              <div class="text-right">
                <v-btn small color="primary" :disabled="!indicadores.formviajes" @click="update('viajes')">Actualizar</v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from "vue";
import { apiv1 } from "../../../libs/apiv1";
import { Auth } from "../../../classes/Auth";

const auth = new Auth();

export default Vue.extend({
  name: "Indicadores",
  data: () => ({
    dialog: false,
    indicadores: {},
    valid: true,
    rules: {
      required: v => !!v || "Campo obligatorio"
    }
  }),
  mounted() {
    this.getIndicadores();
  },
  methods: {
    getIndicadores: function() {
      apiv1({
        url: `project/indicadores/${auth.getProject().id}`,
        method: "GET"
      }).then(res => {
        this.indicadores = res.data;
      });
    },
    updateIndicadores: function() {
      if (this.$refs.form.validate()) {
        apiv1({
          url: `indicadores/${auth.getProject().id}`,
          method: "PUT",
          data: this.indicadores
        }).then(res => {
          this.getIndicadores();
          this.$awn.success(res.data);
          this.dialog = false;
        });
      }
    },
    update(type) {
      if (this.$refs.form.validate()) {
        apiv1({
          url: `indicador/${auth.getProject().id}?name=${type}`,
          method: "PUT",
          data: { val: this.indicadores[type] }
        }).then(res => {
          this.getIndicadores();
          this.$awn.success(res.data);
        });
      }
    }
  }
});
</script>

<style>
</style>